// extracted by mini-css-extract-plugin
export default {"userIcon":"verification_userIcon__ykILb","bullet":"verification_bullet__b1e5x","verified":"verification_verified__frVRg","notVerified":"verification_notVerified__iX541"};